function Info(props) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 9C3 12.3137 5.68629 15 9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9ZM13.9091 9.00007C13.9091 11.7113 11.7112 13.9092 8.99999 13.9092C6.28878 13.9092 4.0909 11.7113 4.0909 9.00007C4.0909 6.28886 6.28878 4.09098 8.99999 4.09098C11.7112 4.09098 13.9091 6.28886 13.9091 9.00007ZM9.00018 11.7263C9.30153 11.7263 9.54582 11.4821 9.54582 11.1809C9.54582 10.8796 9.30153 10.6354 9.00018 10.6354C8.69884 10.6354 8.45455 10.8796 8.45455 11.1809C8.45455 11.4821 8.69884 11.7263 9.00018 11.7263ZM8.45456 10.0908H9.54547C9.54547 9.65538 9.61388 9.57557 10.0621 9.35145C10.8411 8.96194 11.1818 8.56448 11.1818 7.6363C11.1818 6.44756 10.246 5.72721 9.00001 5.72721C7.79503 5.72721 6.81819 6.70405 6.81819 7.90903H7.9091C7.9091 7.30654 8.39752 6.81812 9.00001 6.81812C9.69664 6.81812 10.0909 7.12162 10.0909 7.6363C10.0909 8.07177 10.0225 8.15158 9.57426 8.37571C8.79524 8.76522 8.45456 9.16268 8.45456 10.0908Z"
        fill="#85714D"
      />
    </svg>
  );
}

export default Info;
